// components/VideoDialogWrapper.tsx
import React from "react";
import VideoDialog from "../Pages/VideoDialog";
import { useVideo } from "../Contexts/VideosContext";

const VideoDialogWrapper = () => {
  const {
    open,
    setOpen,
    videoId,
    setVideoId,
    youtubeTitle,
    setYoutubeTitle,
    options,
    setOptions,
    isLiked,
    setIsLiked,
    likedMsg,
    setLikedMsg,
    gitasevalogo,
    setGitasevalogo,
    setIsPiP,
  } = useVideo();

  const handleFavouriteClick = () => {
    setIsLiked((prev:any) => !prev);
    setLikedMsg(true); // fake likedMsg, you can update this as per real logic
  };

  return (
    <VideoDialog
      open={open}
      setOpen={setOpen}
      videoId={videoId}
      youtubeTitle={youtubeTitle}
      setYoutubetitle={setYoutubeTitle}
      options={options}
      isLiked={isLiked}
      likedMsg={likedMsg}
      setLikedMsg={setLikedMsg}
      gitasevalogo={gitasevalogo}
      handleFavouriteClick={handleFavouriteClick}
      setPlayVideo={() => {}}
      playVideo={true}
    />
  );
};

export default VideoDialogWrapper;
